module.exports = __webpack_public_path__ + "static-appopensalud/img/openlegalpro_blue.a2396e6.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openlegalpro_blue.svg
// module id = 1067
// module chunks = 120